export default "__VITE_ASSET__Bs1I9WO5__"